<template>
  <v-dialog max-width="900" scrollable>
    <template v-slot:activator="{ props: activatorProps }">
      <v-btn v-bind="activatorProps" :icon="true" size="large" density="compact" rounded="xl" flat class="mr-1">
        <v-icon :icon="['fas', 'question']" />
        <v-tooltip location="bottom end" activator="parent">
          ПОМОЩЬ
        </v-tooltip>
      </v-btn>
    </template>

    <template v-slot:default="{ isActive }">
      <v-card title="ПОМОЩЬ" rounded="xl">
        <template v-slot:append>
          <v-btn
              rounded="xl"
              text="ПОНЯТНО"
              flat
              color="amber"
              @click="isActive.value = false"
          />
        </template>
        <template v-slot:text>
          <v-row>
            <v-col cols="4">
              <v-alert density="compact" rounded="xl">
                <template v-slot:title>
                  ИНДИКАЦИЯ ПЕРИОДИЧНОСТИ
                </template>
                <template v-slot:text>
                  <v-sheet color="transparent" class="d-flex justify-start align-center" v-for="period of periods" :key="period">
                    <v-avatar class="mr-1" :style="get_gradient(period)" variant="tonal" color="grey" size="20">
                      <v-avatar variant="flat" size="22" class="font-weight-bold">
                        <!-- <v-icon :icon="['fas', get_work_type_icon(doc.type)]" />-->
                      </v-avatar>
                    </v-avatar>
                    <v-card height="20" max-width="28" rounded="md"
                            class="mr-1 d-flex justify-center align-center" variant="flat"
                            elevation="0"
                            color="grey-lighten-2"
                            :style="`${get_gradient(period)};`"
                    >
                      <v-card height="16" min-width="24" rounded="md"
                              class="d-flex justify-center align-center" variant="flat"
                              elevation="0"
                              style="margin: 2px"
                              color="grey-lighten-2"
                      >
                        2
                      </v-card>
                    </v-card>
                    <span>- {{ period }}</span>
                  </v-sheet>
                </template>
              </v-alert>
              <v-alert density="compact" rounded="xl" class="mt-2">
                <template v-slot:title>
                  ЦВЕТОВАЯ ИНДИКАЦИЯ
                </template>
                <template v-slot:text>
                  <v-sheet class="d-flex justify-start align-center" color="transparent" >
                    <v-avatar class="mr-1" variant="flat" color="grey" size="20" />
                    <span>- Техническое обслуживание</span>
                  </v-sheet>
                  <v-sheet class="d-flex justify-start align-center" color="transparent">
                    <v-avatar class="mr-1" variant="flat" color="amber" size="20" />
                    <span>- Испытания</span>
                  </v-sheet>
                  <v-divider class="my-1"/>
                  <v-sheet class="d-flex justify-start align-start" color="transparent">
                    <v-avatar class="mr-1" variant="flat" color="grey" size="20" style="opacity: 0.4;"/>
                    <span>- По данному <v-chip density="compact" size="small">ЗАКАЗ НАРЯДУ</v-chip> уже сформирован документ проведения ТОиППР (Прозрачность 30%)</span>
                  </v-sheet>
                  <v-sheet class="d-flex justify-start align-start" color="transparent">
                    <v-avatar class="mr-1" variant="flat" color="grey" size="20" style="opacity: 0.2;"/>
                    <span>- Применён один из фильтров (Прозрачность 10%)</span>
                  </v-sheet>
                </template>
              </v-alert>
            </v-col>
            <v-col cols="8">
              <v-alert density="compact" rounded="xl">
                <template v-slot:title>
                  ПОРЯДОК ДЕЙСТВИЙ
                </template>
                <template v-slot:text>
                  <v-sheet color="transparent" class="d-flex justify-start align-center" style="overflow-x: auto" v-on:wheel="scroll" id="scrolling_horizontal">
                    <v-sheet class="d-flex flex-column align-center justify-center" color="transparent">
                      <v-sheet color="white" min-width="200" class="pa-2" rounded="xl" position="relative">
                        <v-avatar size="22" color="green">1</v-avatar>
                        Расположить необходимые заказ-наряды в календаре, выделяя их слева, после чего в выбранном дне нажать на свободное пространство.
                      </v-sheet>
                      <p>ИЛИ</p>
                      <v-sheet color="white" min-width="200" class="pa-2" rounded="xl" position="relative">
                        <v-avatar size="22" color="green">1</v-avatar>
                        Воспользоваться автоматической сортировкой заказ-нарядов: <v-avatar color="grey" size="30"><v-icon :icon="['fas', 'dice']"/> </v-avatar>
                        <p><span>ПРИМЕЧАНИЕ: </span>Данная кнопка скрыта, если в списке слева менее 3 документов!</p>
                      </v-sheet>
                    </v-sheet>
                    <v-icon :icon="['fas', 'arrow-right']" class="mx-2" />
                    <v-sheet color="white" min-width="300" class="pa-2" rounded="xl" position="relative">
                      <v-avatar size="22" color="green">2</v-avatar>
                      Проверить, что все необходимые заказ-наряды рассортированы, а так-же отсутствие переработок (Красная индикация в правой части дня <span class="font-weight-bold" style="color: #da4828;">120 / 60</span>).
                      Данная индикация должна быть в зелёных или светло-оранжевых оттенках.
                    </v-sheet>
                    <v-icon :icon="['fas', 'arrow-right']" class="mx-2" />
                    <v-sheet color="white" min-width="300" class="pa-2" rounded="xl" position="relative">
                      <v-avatar size="22" color="green">3</v-avatar>
                      Сохранить внесённые изменения<br>
                      <v-chip density="compact" size="small">ФАЙЛ</v-chip> <v-icon :icon="['fas', 'arrow-right']" class="mx-2" /> <v-chip density="compact" size="small">СОХРАНИТЬ</v-chip>
                    </v-sheet>
                    <v-icon :icon="['fas', 'arrow-right']" class="mx-2" />
                    <v-sheet class="d-flex flex-column align-center justify-center" color="transparent">
                      <v-sheet color="white" min-width="300" class="pa-2" rounded="xl" position="relative">
                        <v-avatar size="22" color="green">4</v-avatar>
                        Распечатать созданный график<br>
                        <v-chip density="compact" size="small">ФАЙЛ</v-chip> <v-icon :icon="['fas', 'arrow-right']" class="mx-2" /> <v-chip density="compact" size="small">ПЕЧАТЬ</v-chip>
                      </v-sheet>
                      <p>И</p>
                      <v-sheet color="white" min-width="400" class="pa-2" rounded="xl" position="relative">
                        <v-avatar size="22" color="green">4</v-avatar>
                        Воспользоваться функцией создания ТОиППР<br>
                        <v-chip density="compact" size="small">ФАЙЛ</v-chip> <v-icon :icon="['fas', 'arrow-right']" class="mx-2" /> <v-chip density="compact" size="small">СОЗДАТЬ ТОиППР</v-chip>
                      </v-sheet>
                    </v-sheet>
                  </v-sheet>
                </template>
              </v-alert>
            </v-col>
          </v-row>
          <v-alert density="compact" rounded="xl"  class="mt-2">
            <template v-slot:title>
              НЕОЧЕВИДНЫЕ ПОДСКАЗКИ
            </template>
            <template v-slot:text>
              <p>1. Для того, чтобы получить информацию по "Заказ-наряду", необходимо зажать левую кнопку мыши на записи в списке. Откроется всплывающее окно с информацией о заказ-наряде.</p>
              <p>2. Для того, чтобы удалить запись из календаря, необходимо навести мышь на ячейку в графике и нажать клавишу <v-chip density="compact" size="small" rounded="small" variant="outlined">DEL</v-chip></p>
              <p>3. Для того, чтобы получить информацию уже о запланированном заказ-наряде, необходимо на него нажать, в правой части рабочей области появится всплывающее окно со всей необходимой информацией по заказ-наряду.</p>
            </template>
          </v-alert>

        </template>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
  export default {
    name: "zn-helper",
    data() {
      return {
        periods: ['Год', 'Полугодие', 'Квартал', 'Месяц']
      }
    },
    methods: {
      scroll: function () {
        document.getElementById('scrolling_horizontal').scrollBy({ left: event.deltaY < 0 ? -30 : 30 })
        event.preventDefault();
      },
      get_gradient: function (period) {
        let s
        switch (period) {
          case 'Квартал':
            s = 100 / 4
            break
          case 'Полугодие':
            s = 100 / 2
            break
          case 'Год':
            s = 100
            break
          case 'Месяц':
            s = 100 / 12
            break
          default:
            s = 0
            break
        }
        return `background: conic-gradient(#9d9d9d 0% ${s}%, ${'rgba(255,255,255,0)'} ${s}% 100%) !important`
      },
    }
  }
</script>
<style scoped>

</style>
